export const Services = () => {
  return (
    <div className="container-fluid service overflow-hidden pt-5">
      <div className="container py-5">
        <div
          className="section-title text-center mb-5 wow fadeInUp"
          data-wow-delay="0.1s"
        >
          <div className="sub-style">
            <h5 className="sub-title text-primary px-3">Categories</h5>
          </div>
          <h1 className="display-5 mb-4">
            Best Air Ticket,Visa & Immigrations Services{" "}
          </h1>
          <p className="mb-0">
            We provide visa processing, air ticket booking, and manpower
            services with expertise and full experience, ensuring the fastest
            possible turnaround.
          </p>
        </div>
        <div className="row g-4">
          <div className="col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.3s">
            <div className="service-item">
              <div className="service-inner">
                <div className="service-img ">
                  <img
                    src="img/air-booking.jpg"
                    className="img-fluid w-100  rounded "
                    alt="Image"
                    style={{ height: 330 }}
                  />
                </div>
                <div className="service-title">
                  <div className="service-title-name">
                    <div className="bg-primary text-center rounded p-3 mx-5 mb-4">
                      <a href="#!" className="h4 text-white mb-0">
                        Air Ticket
                      </a>
                    </div>
                    <a
                      className="btn bg-light text-secondary rounded-pill py-3 px-5 mb-4"
                      href="#!"
                    >
                      Explore More
                    </a>
                  </div>
                  <div className="service-content pb-4">
                    <a href="#!">
                      <h4 className="text-white mb-4 py-3"> Air ticket</h4>
                    </a>
                    <div className="px-4">
                      <p className="mb-4">
                        We provide visa processing, air ticket booking, and
                        manpower services with expertise and full experience,
                        ensuring the fastest possible turnaround.
                      </p>
                      <a
                        className="btn btn-primary border-secondary rounded-pill text-white py-3 px-5"
                        href="#!"
                      >
                        Explore More
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.5s">
            <div className="service-item">
              <div className="service-inner">
                <div className="service-img">
                  <img
                    src="img/service-3.jpg"
                    className="img-fluid w-100 rounded"
                    alt="Image"
                  />
                </div>
                <div className="service-title">
                  <div className="service-title-name">
                    <div className="bg-primary text-center rounded p-3 mx-5 mb-4">
                      <a href="#!" className="h4 text-white mb-0">
                        Tourist Visa
                      </a>
                    </div>
                    <a
                      className="btn bg-light text-secondary rounded-pill py-3 px-5 mb-4"
                      href="#!"
                    >
                      Explore More
                    </a>
                  </div>
                  <div className="service-content pb-4">
                    <a href="#!">
                      <h4 className="text-white mb-4 py-3">Tourist Visa</h4>
                    </a>
                    <div className="px-4">
                      <p className="mb-4">
                        We provide visa processing, air ticket booking, and
                        manpower services with expertise and full experience,
                        ensuring the fastest possible turnaround.
                      </p>
                      <a
                        className="btn btn-primary border-secondary rounded-pill text-white py-3 px-5"
                        href="#!"
                      >
                        Explore More
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.1s">
            <div className="service-item">
              <div className="service-inner">
                <div className="service-img">
                  <img
                    src="img/service-1.jpg"
                    className="img-fluid w-100 rounded"
                    alt="Image"
                  />
                </div>
                <div className="service-title">
                  <div className="service-title-name">
                    <div className="bg-primary text-center rounded p-3 mx-5 mb-4">
                      <a href="#!" className="h4 text-white mb-0">
                        Work Visa
                      </a>
                    </div>
                    <a
                      className="btn bg-light text-secondary rounded-pill py-3 px-5 mb-4"
                      href="#!"
                    >
                      Explore More
                    </a>
                  </div>
                  <div className="service-content pb-4">
                    <a href="#!">
                      <h4 className="text-white mb-4 py-3">Work Visa</h4>
                    </a>
                    <div className="px-4">
                      <p className="mb-4">
                        We provide visa processing, air ticket booking, and
                        manpower services with expertise and full experience,
                        ensuring the fastest possible turnaround.
                      </p>
                      <a
                        className="btn btn-primary border-secondary rounded-pill py-3 px-5"
                        href="#!"
                      >
                        Explore More
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.5s">
            <div className="service-item">
              <div className="service-inner">
                <div className="service-img">
                  <img
                    src="img/service-3.jpg"
                    className="img-fluid w-100 rounded"
                    alt="Image"
                  />
                </div>
                <div className="service-title">
                  <div className="service-title-name">
                    <div className="bg-primary text-center rounded p-3 mx-5 mb-4">
                      <a href="#!" className="h4 text-white mb-0">
                        Business Visa
                      </a>
                    </div>
                    <a
                      className="btn bg-light text-secondary rounded-pill py-3 px-5 mb-4"
                      href="#!"
                    >
                      Explore More
                    </a>
                  </div>
                  <div className="service-content pb-4">
                    <a href="#!">
                      <h4 className="text-white mb-4 py-3">Business Visa</h4>
                    </a>
                    <div className="px-4">
                      <p className="mb-4">
                        We provide visa processing, air ticket booking, and
                        manpower services with expertise and full experience,
                        ensuring the fastest possible turnaround.
                      </p>
                      <a
                        className="btn btn-primary border-secondary rounded-pill text-white py-3 px-5"
                        href="#!"
                      >
                        Explore More
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.1s">
            <div className="service-item">
              <div className="service-inner">
                <div className="service-img">
                  <img
                    src="img/service-1.jpg"
                    className="img-fluid w-100 rounded"
                    alt="Image"
                  />
                </div>
                <div className="service-title">
                  <div className="service-title-name">
                    <div className="bg-primary text-center rounded p-3 mx-5 mb-4">
                      <a href="#!" className="h4 text-white mb-0">
                        Students Visa
                      </a>
                    </div>
                    <a
                      className="btn bg-light text-secondary rounded-pill py-3 px-5 mb-4"
                      href="#!"
                    >
                      Explore More
                    </a>
                  </div>
                  <div className="service-content pb-4">
                    <a href="#!">
                      <h4 className="text-white mb-4 py-3">Students Visa</h4>
                    </a>
                    <div className="px-4">
                      <p className="mb-4">
                        We provide visa processing, air ticket booking, and
                        manpower services with expertise and full experience,
                        ensuring the fastest possible turnaround.
                      </p>
                      <a
                        className="btn btn-primary border-secondary rounded-pill text-white py-3 px-5"
                        href="#!"
                      >
                        Explore More
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.3s">
            <div className="service-item">
              <div className="service-inner">
                <div className="service-img">
                  <img
                    src="img/service-2.jpg"
                    className="img-fluid w-100 rounded"
                    alt="Image"
                  />
                </div>
                <div className="service-title">
                  <div className="service-title-name">
                    <div className="bg-primary text-center rounded p-3 mx-5 mb-4">
                      <a href="#!" className="h4 text-white mb-0">
                        Residence Visa
                      </a>
                    </div>
                    <a
                      className="btn bg-light text-secondary rounded-pill py-3 px-5 mb-4"
                      href="#!"
                    >
                      Explore More
                    </a>
                  </div>
                  <div className="service-content pb-4">
                    <a href="#!">
                      <h4 className="text-white mb-4 py-3">Residence Visa</h4>
                    </a>
                    <div className="px-4">
                      <p className="mb-4">
                        We provide visa processing, air ticket booking, and
                        manpower services with expertise and full experience,
                        ensuring the fastest possible turnaround.
                      </p>
                      <a
                        className="btn btn-primary border-secondary rounded-pill text-white py-3 px-5"
                        href="#!"
                      >
                        Explore More
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
